<template>
  <div class="uesr-layout">
    <div class="left">
      <!-- 欢迎信息 -->
      <div class="l-top">
        <div class="lt-info">
          <div class="lt-welcome">
            <div class="ltw-top">
              <img class="avatar" src="@/assets/image/14.png" />
              <span class="ltw-tips"
                >{{ welcome }}{{ info.nickname || user.id }}</span
              >
            </div>
          </div>
          <div
            style="
              display: flex;
              width: 30%;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div class="level" v-if="info.level">{{ info.level }}</div>
              <router-link to="/customer/account/">
                <img class="u-icon" src="@/assets/image/15.png" />
              </router-link>
              <router-link to="/customer/account/security">
                <img class="u-icon" src="@/assets/image/16.png" />
              </router-link>
              <router-link to="/customer/account/security">
                <img class="u-icon" src="@/assets/image/17.png" />
              </router-link> 
          </div>
        </div>
        <div class="lg-record" style="margin-top: 77px">
          <span>上次登录：{{ info.lastLoginTime }}</span
          ><span style="margin-left: 20px"
            >{{ info.lastLoginIp }} {{ info.lastAddr }}</span
          >
        </div>
      </div>
      <div class="lb-title">
        <span class="title">我的域名</span>
        <router-link class="to-more" to="/customer/domain">查看全部 ></router-link>
      </div>
      <div class="l-bottom">
        <div class="lb-main">
          <div class="item">
            <span class="count">{{ info.domainCount }}</span>
            <span>我拥有的域名</span>
          </div>
          <div class="item">
            <span class="count">{{ info.redeemCount }}</span>
            <span>赎回期的域名</span>
          </div>
          <div class="item">
            <span class="count">{{ info.waitPushCount }}</span>
            <span>待接收的push域名</span>
          </div>
          <div class="item">
            <span class="count">{{ info.domainTemplateCount }}</span>
            <span>域名模板的数量</span>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="rt-bottom rb-bottom">
        <div class="rt-title">
          <div class="l-main">
            <div class="item wallet">
              <span>我的钱包</span>
            </div>
            <div class="moneyView">
              <div class="lm-item">
                <span>可用余额：</span>
                <span class="lmi-text">{{ balance.toFixed(2) }}</span>
              </div>
              <div class="lm-item">
                <span>冻结余额：</span>
                <span class="lmi-text">{{ freezeAmount.toFixed(2) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="rt-section">
          <router-link class="item" to="/customer/domain">我的域名</router-link>
          <router-link class="item" to="/customer/template">我的模板</router-link>
          <router-link class="item" to="/customer/transferout">我的转出</router-link>
          <router-link class="item" to="/customer/transferin">我的转入</router-link>
          <router-link class="item" to="/customer/push">域名PUSH</router-link>
          <router-link class="item" to="/customer/order">域名订单</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { userInfo } from "api/customer.js";
export default {
  //name: "customer",//name: "user",
  data() {
    return {
      info: {},
    };
  },
  computed: {
    ...mapState(["user", "freezeAmount", "balance"]),
    welcome() {
      let title = "";
      let hours = new Date().getHours();
      if (hours < 12) {
        title = "上午好！";
      } else if (hours >= 12 && hours < 14) {
        title = "中午好！";
      } else if (hours >= 14 && hours < 19) {
        title = "下午好！";
      } else if (hours >= 19 && hours <= 24) {
        title = "晚上好！";
      }
      return title;
    },
  },
  created() {
    this.req_userInfo();
  },
  methods: {
    async req_userInfo() {
      try {
        const { code, data } = await userInfo();
        if (code === 200) {
          this.info = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.uesr-layout {
  display: flex;
  justify-content: space-between;
  min-height: 100%;
  padding-left: 10px;
  background-color: #f0f3f6;
  .left {
    // flex: 0 1 820px;
    flex: 2;
    .left-info {
      height: 300px;
    }
    .l-top {
      // padding: 56px 48px 48px;
      background-color: #fff;
      height: 300px;

      // display: flex;
      // justify-content: space-between;
      .avatar {
        width: 36px;
        height: 36px;
        margin-right: 10px;
      }
      .lt-info {
        display: flex;
        padding-top: 80px;
        width: 83%;
        margin: 0 auto;
        justify-content: space-between;
        .ltw-top {
          display: flex;
          align-items: center;
          .ltw-tips {
            color: #4f5867;
            font-size: 24px;
            font-weight: bold;
            margin-right: 10px;
          }
        }
      }
      .u-icon {
        width: 22px;
        height: 22px;
        // margin-right: 10px;
      }
      .lg-record {
        font-weight: 400;
        font-size: 14px;
        color: #747474;
        width: 83%;
        margin: 0 auto;
      }
    }
    .level {
      width: 87px;
      height: 30px;
      border-radius: 5px;
      text-align: center;
      line-height: 30px;
      font-weight: 600;
      color: #73bd77;
      font-size: 12px;
      border: 1px solid #73bd77;
    }

    .lb-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100px;
      width: 100%;
      margin: 0 auto;
      .title {
        font-weight: 600;
        color: #4f5867;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .l-bottom {
      height: 300px;
      .lb-main {
        display: flex;
        justify-content: space-between;

        .item {
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 24%;
          height: 300px;
          span {
            color: #333;
          }
          .count {
            margin-bottom: 65px;
            line-height: 1;
            color: #000;
            font-size: 48px;
            font-weight: bold;
          }
        }
      }
    }
  }
  .right {
    margin-left: 1%;
    flex: 2;
    // flex: 0 1 670px;
    .rt-bottom {
      // padding: 48px 50px;
      // background-color: #fff;
      .rt-title {
        .l-main {
          // background: url("~@/assets/image/u-zh-icon.png");
          // background-size: cover;
          // display: flex;
          height: 300px;
          background: #fff;
          .wallet {
            font-size: 24px;
            font-weight: 600;
            color: #4f5867;
            text-align: center;
            padding: 40px 0;
          }
          .moneyView {
            display: flex;
            justify-content: space-between;
            width: 94%;
            margin: 0 auto;
          }
          .lm-item {
            height: 144px;
            background: #759de6;
            border-radius: 10px;
            width: 49%;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 20px;
            .lmi-text {
              font-size: 32px;
              margin-right: 20px;
            }
          }
        }
      }
      .rt-main {
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        justify-content: center;
        .item {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            color: #333;
          }
          .count {
            margin-bottom: 20px;
            line-height: 1;
            color: #3992e9;
            font-size: 48px;
            font-weight: bold;
          }
        }
      }
    }
    .rt-section {
      display: flex;
      flex-wrap: wrap;
      height: 300px;
      margin-top: 100px;
      justify-content: space-between;
      .item {
        // width: 180px;
        flex: 0 0 32.5%;
        padding: 0 10px;
        height: 140px;
        line-height: 140px;
        background-color: #fff;
        text-align: center;
        font-weight: 800;
        transition: all 0.3s;
        font-size: 22px;
        font-weight: 600;
        color: #315491;
        &:hover {
          background-color: #315491;
          color: #fff;
        }
        span {
          color: #ff5c35;
        }
        // &:nth-child(2n) {
        //   margin-left: 5%;
        //   margin-right: 0;
        // }
      }
    }
    .rt-bottom.rb-bottom {
      // padding: 45px 50px 40px;
    }
  }
}
</style>
